import React from 'react';
import PropTypes from 'prop-types';

import spinnerSVG from './spinner.svg';
import styles from './Spinner.css';

const IPropTypes = {
  className: PropTypes.string,
  imgClassName: PropTypes.string,
};

const defaultProps = {
  className: '',
  imgClassName: '',
};

const Spinner = props => (
  <div className={[styles.container, props.className].join(' ')}>
    <img className={[props.imgClassName, styles.spinner].join(' ')} alt="" src={spinnerSVG} />
  </div>
);

Spinner.propTypes = IPropTypes;
Spinner.defaultProps = defaultProps;

export { Spinner };



// WEBPACK FOOTER //
// ./src/common/spinner/Spinner.jsx